import { render, staticRenderFns } from "./InvoiceViewFroPaksitaniClient.vue?vue&type=template&id=93577f78&"
import script from "./InvoiceViewFroPaksitaniClient.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewFroPaksitaniClient.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceViewFroPaksitaniClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports